// CarouselBanner.js
import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import emlaktv from "./images/emlaktv.jpg"

const CarouselBanner = () => {
    const slides = [
        {
          text: "Emlak Vitrini sizi Zahmetten Kurtarıyor!",
          bg: "black" // pastel mavi
        },
        {
          text: "İlanlarınız Büyük Ekranda Daha Etkileyici.",
          bg: "black" // pastel turuncu
        },
        {
          text: "Sadece İnternette Değil, TV’de de Görün!",
          bg: "black" // pastel pembe
        },
        {
          text: "Kendi TV Vitrininizi Oluşturun – Basit, Hızlı, Profesyonel.",
          bg: "black" // pastel yeşil
        },
        {
          text: "Artık Elle İlan Yazmak Yok!",
          bg: "black" // pastel mor
        },
        {
          text: "Tek Seferde Hem Online Dükkanınızda Hem Vitrininizde !",
          bg: "black" // pastel sarı
        },
        {
          text: "Marka Değerinizi Ekrana Taşıyın.",
          bg: "black" // pastel mavi-gri
        }
      ];

  return (
    <Carousel
      autoPlay
      infiniteLoop
      showThumbs={false}
      showStatus={false}
      showArrows={false}
      interval={4000}
    >
      {slides.map((slide, index) => (
        <div key={index} style={{ 
          background: slide.bg,
          height: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <h2 style={{
            color: '#FEBA17',
            fontSize: '44px',
            textAlign: 'center',
            padding: '0 20px',
            fontWeight: 'bold',
            textShadow: '1px 1px 4px rgba(204, 174, 174, 0.6)'
          }}>
            {slide.text}
          </h2>
        </div>
      ))}
    </Carousel>
  );
};

export default CarouselBanner;
